import { loadOnboardingResult, saveOnboardingResult } from "../onboarding";
import type { PatchProfileResponse } from "./use-profile-edit";

export function persistProfilePatchResponse(data: PatchProfileResponse) {
  const current = loadOnboardingResult();
  if (!current) {
    return;
  }

  const profilePatch =
    data.profile && typeof data.profile === "object"
      ? (data.profile as Partial<typeof current.profile>)
      : {};
  const nextProfile = {
    ...current.profile,
    ...profilePatch,
  };
  if (data.snapshot?.id) {
    nextProfile.current_snapshot_id = data.snapshot.id;
  }

  saveOnboardingResult({
    ...current,
    profile: nextProfile,
    financials:
      data.financials && typeof data.financials === "object"
        ? (data.financials as typeof current.financials)
        : current.financials,
  });
}
